import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase.js';

const defaultConfig = {
  currentSeason: '5',
  adminEmails: [],
  showSignUps: false,
  signUpText: '',
  showDraftBoard: false,
  returningPlayerFee: 100,
  newPlayerFee: 150,
  showPlayoffBracket: true,
  gamesPerTeam: 12,
  locations: [
    { id: 'sbca', name: 'South Boston Catholic Academy', abbv: 'SBCA' },
    { id: 'b&gc', name: 'Boys & Girls Club', abbv: 'B&GC' },
    { id: 'jpt-school', name: 'Joseph P. Tynan School', abbv: 'TYNAN' },
    { id: 'condon', name: 'Condon School', abbv: 'CONDON' }
  ]
};

const ConfigContext = createContext({ ...defaultConfig, configLoaded: false, refreshConfig: () => {} });

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState(defaultConfig);
  const [configLoaded, setConfigLoaded] = useState(false);

  const fetchConfig = useCallback(async () => {
    try {
      const configDoc = await getDoc(doc(db, 'config', 'app'));
      if (configDoc.exists()) {
        setConfig({ ...defaultConfig, ...configDoc.data() });
      }
    } catch (err) {
      console.error('Failed to load app config, using defaults:', err);
    } finally {
      setConfigLoaded(true);
    }
  }, []);

  useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  return (
    <ConfigContext.Provider value={{ ...config, configLoaded, refreshConfig: fetchConfig }}>
      {children}
    </ConfigContext.Provider>
  );
}

export function useConfig() {
  return useContext(ConfigContext);
}
